import { MessagesSquareIcon } from 'lucide-react'

import { ASSESSMENT_COMMENTS_LABELS } from './labels'

export const AssessmentCommentsEmptyState = () => (
  <div className='m-auto flex flex-col items-center gap-4'>
    <div className='flex size-12 items-center justify-center rounded-full bg-main-background-subtle-gray'>
      <MessagesSquareIcon className='size-6 text-main-foreground-primary' />
    </div>
    <div className='flex flex-col items-center gap-1 text-center'>
      <span className='text-main-foreground-primary text-heading-xsmall'>
        {ASSESSMENT_COMMENTS_LABELS.emptyTitle}
      </span>
      <span className='text-main-foreground-secondary text-body-default'>
        {ASSESSMENT_COMMENTS_LABELS.emptySubtitle}
      </span>
    </div>
  </div>
)
